"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const nucleusToString_1 = __importDefault(require("../utility/nucleusToString"));
function useSpectraByActiveNucleus() {
    const { data, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    return (0, react_1.useMemo)(() => {
        if (data) {
            return (data.filter((spectrum) => activeTab === (0, nucleusToString_1.default)(spectrum.info.nucleus)) || []);
        }
        return [];
    }, [activeTab, data]);
}
exports.default = useSpectraByActiveNucleus;
